import {
  Alert,
  Dialog,
  Flex,
  FlexColumn,
} from '@elementary/common-ui/components';
import { styled, Typography } from '@mui/material';
import { ReactComponent as InfoIconBase } from '@elementary/common-ui/assets/16x16/info.svg';
import SensitiveInfoDisplay from './SensitiveInfoDisplay';
import { TokenType } from './types';

const InfoIcon = styled(InfoIconBase)`
  path {
    fill: ${({ theme }) => theme.palette.common.gray4};
  }
`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  token: string;
  tokenType: TokenType;
};

const tokenTypeCopy: Record<
  TokenType,
  { typeLabel: string; displayLabel: string; tiedTo: string }
> = {
  personal: {
    typeLabel: 'user',
    displayLabel: 'User token',
    tiedTo: 'your user permissions',
  },
  account: {
    typeLabel: 'account',
    displayLabel: 'Account token',
    tiedTo: 'your account permissions',
  },
  runtime: {
    typeLabel: 'runtime',
    displayLabel: 'Runtime token',
    tiedTo: 'this runtime',
  },
};

const SuccessStageDialog = ({ isOpen, onClose, token, tokenType }: Props) => {
  const { typeLabel, displayLabel, tiedTo } = tokenTypeCopy[tokenType];

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      onConfirmButtonClick={onClose}
      title="Generate token"
      confirmText="Done"
      hideCancelButton
      closeOnBackdropClick={false}
      footerMessage={
        <Flex sx={{ gap: 1, alignItems: 'center' }}>
          <InfoIcon />
          <Typography sx={{ fontSize: '12px', color: 'common.gray4' }}>
            Notice: This key is unique and tied to {tiedTo}.
          </Typography>
        </Flex>
      }
      message={
        <FlexColumn sx={{ gap: 3 }}>
          <Alert severity="info">
            Copy and save the {typeLabel} token below —{' '}
            <span style={{ fontWeight: 'bold' }}>
              it won&apos;t be shown again.
            </span>
          </Alert>

          <SensitiveInfoDisplay label={displayLabel} value={token} />
        </FlexColumn>
      }
    />
  );
};

export default SuccessStageDialog;
